import { GanttWorkItem } from "../../types/gantt";
import { leftPx, widthPx } from "../../utils/ganttUtils";

/* Convert ISO date → DD/MM */
function formatDate(value: string) {
  const d = new Date(value);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}`;
}

export function PlannedBar({
  item,
  timelineStart,
  pxPerDay,
  timelineWidth
}: {
  item: GanttWorkItem;
  timelineStart: Date;
  pxPerDay: number;
  timelineWidth: number;
}) {
  if (!item.planned) return null;

  const start = new Date(item.planned.start);
  const end = new Date(item.planned.end);

  const left = leftPx(start, timelineStart, pxPerDay);
  const width = Math.max(widthPx(start, end, pxPerDay), 8);

  const startLabel = formatDate(item.planned.start);
  const endLabel = formatDate(item.planned.end);

  const isPositiveWorkId = item.workId > 0;

  const barClass = isPositiveWorkId
    ? "absolute top-[6px] h-3 bg-blue-600 group z-10"
    : "absolute top-[6px] h-3 bg-blue-300 group z-10";



  function getDayDiff(start: Date, end: Date) {
    const msPerDay = 1000 * 60 * 60 * 24;

    const startUTC = Date.UTC(
      start.getFullYear(),
      start.getMonth(),
      start.getDate()
    );

    const endUTC = Date.UTC(
      end.getFullYear(),
      end.getMonth(),
      end.getDate()
    );

    return Math.ceil((endUTC - startUTC) / msPerDay) + 1;
  }

  const durationDays = getDayDiff(start, end);
  const showInsideLabels = durationDays > 45;

  const insideLabelStyle: React.CSSProperties = {
   // fontFamily: "Segoe UI, sans-serif",
   fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    color: "#FFFFFF",
    textShadow: "0 0 2px rgba(0,0,0,0.35)"
  };

  const outsideLabelStyle: React.CSSProperties = {
   // fontFamily: "Segoe UI, sans-serif",
   fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    color: "#000000",
    textShadow: "0 0 2px white"
  };

  

  return (
    <div
      className={barClass}
      style={{ left, width }}
    >
      {/* ================= TOOLTIP ================= */}
      <div className="pointer-events-none absolute -top-14 left-1/2 -translate-x-1/2 z-50 hidden group-hover:block">
        <div className="rounded bg-gray-900 text-white text-xs px-3 py-2 shadow-lg whitespace-nowrap">
          <div>
            <span className="font-semibold">Work:</span> {item.workElement}
          </div>
          <div>
            <span className="font-semibold">Type:</span> Planned
          </div>
          <div>
            <span className="font-semibold">Start:</span> {startLabel}
          </div>
          <div>
            <span className="font-semibold">End:</span> {endLabel}
          </div>
        </div>
      </div>
      {/* =========================================== */}

      {showInsideLabels ? (
        <>
          <div
            className="absolute left-2 top-1/2 -translate-y-1/2 whitespace-nowrap pointer-events-none"
           //className="gantt-text absolute left-1 top-1/2 -translate-y-1/2 whitespace-nowrap pointer-events-none"
            style={insideLabelStyle}
          >
            {startLabel}
          </div>

          <div
            className="absolute right-2 top-1/2 -translate-y-1/2 whitespace-nowrap pointer-events-none"
          // className="gantt-text absolute right-1 top-1/2 -translate-y-1/2 whitespace-nowrap pointer-events-none"
            style={insideLabelStyle}
          >
            {endLabel}
          </div>
        </>
      ) : (
        <>
          <div
            className="absolute top-1/2 right-full mr-1  -translate-y-1/2 whitespace-nowrap pointer-events-none"
           // className="gantt-text absolute top-1/2 right-full -translate-y-1/2 whitespace-nowrap pointer-events-none"
            style={outsideLabelStyle}
          >
            {startLabel}
          </div>

          <div
            className="absolute top-1/2 left-full ml-1  -translate-y-1/2 whitespace-nowrap pointer-events-none"
           // className="gantt-text absolute top-1/2 left-full -translate-y-1/2 whitespace-nowrap pointer-events-none"
            style={outsideLabelStyle}
          >
            {endLabel}
          </div>
        </>
      )}
      

    </div>
  );
}